import { lazy, Suspense } from "react";
import Loader from '../custom/loader/main';

const Main = lazy(() => import('../components/report/cummulativeResults/main'));

const CummulativeResult = () => {

    return (
        <Suspense fallback={<Loader/>}>
            <Main/>
        </Suspense> 
    )

}

export default CummulativeResult;